import { render, staticRenderFns } from "./CostBearerMailServicePreview.vue?vue&type=template&id=804861f2&"
import script from "./CostBearerMailServicePreview.vue?vue&type=script&lang=ts&"
export * from "./CostBearerMailServicePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports